import * as tslib_1 from "tslib";
import { Select, Tooltip } from "@h3/antd-vue";
import { Component } from "vue-property-decorator";
import { DropdownControl } from "../control/dropdown-control";
let dropdownMulti = class dropdownMulti extends DropdownControl {
    constructor() {
        super(...arguments);
        this.currentPage = 0; //当前页码
        this.searchValue = ''; //模糊搜索输入值
    }
    onChange(val) {
        this.hasSelectBatchImport = false;
        if (val && val.length > 0) {
            this.setValue(Array.isArray(val) ? val.slice() : val);
        }
        else {
            this.ctrl.value = null;
        }
        this.val = val;
        //模糊搜索有值时
        if (this.searchValue) {
            this.searchValue = '';
            this.currentPage = 0;
            super.getOptions(this.currentPage, '');
        }
        if (!this.multiple) {
            return;
        }
        super.resetDisableds();
    }
    /**
     * 下拉框查询事件
     */
    handleSearch(value) {
        this.searchValue = value;
        this.currentPage = 0;
        super.getOptions(this.currentPage, value);
    }
    /**
     * 下拉框滚动回调事件
     */
    onPopupScroll(e) {
        //数据字典数据类型不执行滚动加载
        if (this.control.options.dictionariesData) {
            return;
        }
        let isJson = this.isJSON(this.controlOpts.options);
        //自定义数据类型不执行滚动加载
        if (!isJson) {
            return;
        }
        const { target } = e;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            let isDropDownScrollComplete = localStorage.getItem('isDropDownScrollComplete');
            console.log('业务数据滚动加载是否完成isDropDownScrollComplete：', isDropDownScrollComplete);
            if (isDropDownScrollComplete && isDropDownScrollComplete === 'true') {
                return;
            }
            this.currentPage++;
            super.getOptions(this.currentPage, this.searchValue);
        }
    }
    isJSON(str) {
        if (typeof str === 'string') {
            try {
                var obj = JSON.parse(str);
                if (typeof obj === 'object' && obj) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                return false;
            }
        }
    }
    getOPt() {
        localStorage.setItem('isDropDownScrollComplete', 'false');
        this.currentPage = 0;
        super.getOptions(this.currentPage, '');
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
    destroyed() {
        super.destroyed();
    }
};
dropdownMulti = tslib_1.__decorate([
    Component({
        name: "dropdownMulti",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], dropdownMulti);
export default dropdownMulti;
